// CubeSpawn.tsx — the owner's easter egg: click (mouse/pen) and drag
// anywhere on the page to spawn loose faces of the mark's own cube; every
// six pull together into one real isometric cube, hold, then fade. Mounted
// by Landing.tsx as the FIRST child of .landing, an absolutely positioned
// layer sized to the whole page root and stacked BEHIND every section's
// own content (Landing.css: `.landing > header, .landing > section` sit at
// z-index: 1; this layer sits at z-index: 0 — see CubeSpawn.css).
//
// This component owns no state and draws nothing itself: it renders the
// empty layer div and hands it to initCubeSpawn (src/motion/cubeSpawn.ts),
// which does everything else — listeners, spawning, the physics — the same
// "imperative motion module" shape markChoreography.ts and mintHandoff.ts
// already use.
import { useEffect, useRef } from 'react';
import { initCubeSpawn } from '../motion/cubeSpawn';
import './CubeSpawn.css';

export function CubeSpawn() {
  const layerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const layer = layerRef.current;
    if (!layer) return;
    return initCubeSpawn(layer);
  }, []);

  return <div className="cube-spawn" aria-hidden="true" ref={layerRef} />;
}
